<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :config="config"
          @references="references"
        />

        <v-dialog
          v-model="openReference"
          max-width="800px">

          <app-table
            v-if="openReference"
            :config="referenceConfig"
            :hidden-fields="{ pharmacy_id: pharmacy.id }"
            :filters="{ pharmacy_id: pharmacy.id }"
            :subtitle="pharmacy.name"
            modal
            no-search
            hide-upsert
            inline-upsert
            title="Pharmacy references"
            @close="openReference=false" />

        </v-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import referenceConfig from './config_reference.js'

export default {
  data () {
    return {
      config,
      pharmacy: {},
      openReference: false,
      referenceConfig
    }
  },
  methods: {
    references (pharmacy) {
      this.pharmacy = pharmacy
      this.openReference = true
    }
  }
}
</script>
